import config from '../../config'
import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  header
} from './base'

const basic = {
  // 经销商分组
  async GetDealerGroupList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateDealerGroup(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async ActiveDealerGroup(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerGroup(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelDealerGroup(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/Delete',
      type: 'post',
      data
    })
    return response
  },
  // banner
  async GetBannerList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Banner/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateBanner(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Banner/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async ActiveBanner(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Banner/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetBanner(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Banner/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelBanner(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Banner/Delete',
      type: 'post',
      data
    })
    return response
  },
  // DealerAddress
  async GetDealerAddressList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerAddress/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateDealerAddress(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerAddress/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerDefaultAddress(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerAddress/GetDefaultAddress',
      type: 'get',
      data
    })
    return response
  },
  async GetDealerAddress(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerAddress/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelDealerAddress(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerAddress/Delete',
      type: 'post',
      data
    })
    return response
  },
  //货运部
  async GetDealerFreightList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/FreightDepartment/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateDealerFreight(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/FreightDepartment/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async DelDealerFreight(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/FreightDepartment/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerFreight(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/FreightDepartment/GetById',
      type: 'get',
      data
    })
    return response
  },
  async GetDealerDeafultFreight(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/FreightDepartment/GetDealerDeafultFreight',
      type: 'get',
      data
    })
    return response
  },
  //  员工
  async GetEmployeeList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetSaleEmployeePaged(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/GetSaleEmployeePaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateEmployee(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async ActiveEmployee(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetEmployee(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelEmployee(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Employee/Delete',
      type: 'post',
      data
    })
    return response
  },
  // 销售组织
  async GetOrganizationList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async ActiveOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetOrganizationSelectByDealerId(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/GetOrganizationSelectByDealerId',
      type: 'get',
      data
    })
    return response
  },
  async GetOrganizationSelect(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/GetOrganizationSelect',
      type: 'get',
      data
    })
    return response
  },
  // 部门
  async GetDepartmentList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateDepartment(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  

  async ActiveDepartment(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetDepartment(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelDepartment(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetDepartmentSelect(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/GetDepartmentSelect',
      type: 'get',
      data
    })
    return response
  },
  // 经销商
  async GetDealerList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerOrgList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/GetDealerOrgList',
      type: 'get',
      data
    })
    return response
  },
  async GetDealerSelectList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/GetSelectPaged',
      type: 'post',
      data
    })
    return response
  },
  async AddOrUpdateDealer(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async ActiveDealer(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async ActiveOrganzationOpt(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/IsActiveOrganzationOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerSaleEmployee(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/GetSaleEmployee',
      type: 'get',
      data
    })
    return response
  },
  async GetDealer(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/GetById',
      type: 'get',
      data
    })
    return response
  },
  async DelDealer(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dealer/Delete',
      type: 'post',
      data
    })
    return response
  },
  // 经销商账号
  async GetDealerUserList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/GetAll',
      type: 'post',
      data
    })
    return response
  },
  async AddDealerUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateDealerUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/Update',
      type: 'post',
      data
    })
    return response
  },
  async DelDealerUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/Delete',
      type: 'post',
      data
    })
    return response
  },
  async ActiveDealerUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetDealerUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/Get',
      type: 'get',
      data
    })
    return response
  },
  async ResetDealerUserPassword(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerUser/ResetPassword',
      type: 'post',
      data
    })
    return response
  },
  // 信用管理
  async GetCreditList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Credit/GetPaged',
      type: 'post',
      data
    })
    return response
  },

  async GetCreditDetailList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Credit/GetDetailPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetOccupyCreditDetailList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Credit/GetOccupyDetailPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetAvailableBalanceByDealerId(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Credit/GetAvailableBalanceByDealerId',
      type: 'get',
      data
    })
    return response
  },
  async ReSyncCredit(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Credit/ReSync',
      type: 'post',
      data
    })
    return response
  },
}
export default basic



// WEBPACK FOOTER //
// ./src/common/api/basic.js